import React from 'react';

const FinancialPlanningReturningToIndiaBottomline = () => {
  const benefits = [
    {
      title: "Strategic Repatriation Timing",
      description: "Planning your financial return with careful consideration of tax-year transitions, investment liquidation schedules, and foreign exchange rate opportunities maximizes the value of assets being transferred to India."
    },
    {
      title: "Tax Residence Optimization",
      description: "Structuring your return to properly establish Resident Indian status while managing foreign assets and income sources minimizes tax complications and potential double taxation during your transition period."
    },
    {
      title: "Investment Portfolio Realignment",
      description: "Adapting your investment strategy to India's unique financial landscape with appropriate allocation between equity, real estate, and fixed income creates immediate financial stability while positioning for long-term growth."
    },
    {
      title: "Financial Integration Roadmap",
      description: "Establishing banking relationships, building local credit history, and navigating domestic financial systems prior to your physical return facilitates a seamless financial transition without disrupting your wealth momentum."
    }
  ];

  return (
    <div className="w-full bg-gradient-to-br from-[#113262] to-[#1C52A0] py-12 px-8">
      <div className="max-w-6xl w-full mx-auto px-4 sm:px-6 lg:px-8 py-4 md:py-6 lg:py-8">
        <div className="text-center mb-16">
          <h2 className="text-white text-2xl md:text-3xl lg:text-4xl font-bold mb-4">
            Bottomline: Benefits of Strategic Financial Planning When Returning To India
          </h2>
          <div className="w-24 h-1 bg-[#F49611] mx-auto mt-4"></div>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-16">
          {benefits.map((benefit, index) => (
            <div key={index} className="relative">
              {/* Decorative number */}
              <div className="absolute -left-8 top-0 text-6xl font-bold text-white opacity-30">
                {index + 1}
              </div>
              
              {/* Content */}
              <div className="relative">
                <div className="flex items-start space-x-4">
                  {/* Vertical line decoration */}
                  <div className="hidden md:block w-1 h-full bg-gradient-to-b from-[#F49611] to-transparent"></div>
                  
                  <div className="flex-1">
                    <h3 className="text-[#F49611] text-xl font-semibold mb-4">
                      {benefit.title}
                    </h3>
                    <p className="text-white/80 text-base leading-relaxed">
                      {benefit.description}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default FinancialPlanningReturningToIndiaBottomline;